<template>
  <div class="monitoring-facility-status-container">
    <div class="table-prefix-box">
      <div class="btn-box">
        <el-button-group class="mr-10">
          <el-button @click="getData" size="mini" type="primary" icon="el-icon-search">查询
          </el-button>
          <el-button @click="reset" size="mini" type="primary" icon="el-icon-refresh">重置</el-button>
          <el-button @click="download" size="mini" type="primary" icon="el-icon-download">导出
          </el-button>
        </el-button-group>
      </div>
      <div class="search-box mt-15">
        <!--<div class="item">-->
          <!--<span class="span">筛选条件</span>-->
          <!--<el-select size="mini" v-model="obj.select1" placeholder="请选择条件">-->
            <!--<el-option v-for="item in types1" :key="item.value" :label="item.label"-->
              <!--:value="item.value"></el-option>-->
          <!--</el-select>-->
        <!--</div>-->
        <div class="item">
          <span class="span">甲板</span>
          <el-select size="mini" v-model="obj.select" placeholder="请选择条件">
            <el-option v-for="item in decks" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="item">
          <span class="span">安装区域</span>
          <el-select size="mini" v-model="obj.select" placeholder="请选择条件">
            <el-option v-for="item in areas" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="item">
          <span class="span">船舱分段</span>
          <el-select size="mini" v-model="obj.select" placeholder="请选择条件">
            <el-option v-for="item in cabins" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="item">
          <span class="span">设备类型</span>
          <el-select size="mini" v-model="obj.select" placeholder="请选择条件">
            <el-option v-for="item in deviceTypes" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="item">
          <span class="span">设备工作状态</span>
          <el-select size="mini" v-model="obj.select" placeholder="请选择条件">
            <el-option v-for="item in deviceStatus" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="item">
          <div class="span">设备名称</div>
          <el-input v-model="obj.txt11" placeholder="请输入设备名称" size="mini"></el-input>
        </div>
      </div>
    </div>

    <div class="table mt-15">
      <el-table v-loading="tableLoading" border ref="table" :data="list" highlight-current-row
        @current-change="handleCurrentChange" style="width:100%">
        <el-table-column label="设备编写" property="id"></el-table-column>
        <el-table-column label="设备名称"></el-table-column>
        <el-table-column label="设备类型"></el-table-column>
        <el-table-column label="安装位置"></el-table-column>
        <el-table-column label="设备工作状态"></el-table-column>
        <el-table-column label="故障原因"></el-table-column>
        <el-table-column label="处境时间"></el-table-column>
        <el-table-column label="查看"></el-table-column>
      </el-table>
    </div>

    <div class="pagination pt-10 t-center">
      <el-pagination background layout="total,sizes,prev,pager,next,jumper"
        :page-size="pagination.size" :page-sizes="[10,20,30,50]"
        :current-page.sync="pagination.page" :total="pagination.total" @size-change="changeSize"
        @current-change="changeCurrent"></el-pagination>
    </div>

    <el-dialog :title="currentRow?'编辑':'新建'" width="400px" :visible.sync="addDialogShow">
      <div class="add-box">
        <div class="o-hidden">
          <span class="span">名称</span>
          <el-input size="mini" v-model="addobj.name"></el-input>
        </div>
        <div class="o-hidden">
          <span class="span">名称</span>
          <el-input size="mini" v-model="addobj.name"></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="addDialogShow=false">取 消</el-button>
        <el-button size="mini" type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import { tool } from "../../common/js/tool.js";
import { Loading } from "element-ui";
export default {
  data() {
    return {
      types1: [
        { value: "全部", label: "全部" },
        { value: "按甲板显示", label: "按甲板显示" },
        { value: "按安装区域显示", label: "按安装区域显示" },
        { value: "按船舱分段显示", label: "按船舱分段显示" },
        { value: "按设备类型显示", label: "按设备类型显示" },
        { value: "按设备工作状态显示", label: "按设备工作状态显示" }
      ],
      decks: [
        { value: "全部", label: "全部" },
        { value: "甲板1", label: "甲板1" },
        { value: "甲板2", label: "甲板2" },
        { value: "甲板3", label: "甲板3" },
        { value: "甲板4", label: "甲板4" },
        { value: "甲板5", label: "甲板5" }
      ],
      areas: [
        { value: "全部", label: "全部" },
        { value: "安装区域1", label: "安装区域1" },
        { value: "安装区域2", label: "安装区域2" },
        { value: "安装区域3", label: "安装区域3" }
      ],
      cabins: [
        { value: "全部", label: "全部" },
        { value: "船舱分段1", label: "船舱分段1" },
        { value: "船舱分段2", label: "船舱分段2" },
        { value: "船舱分段3", label: "船舱分段3" }
      ],
      deviceTypes: [
        { value: "全部", label: "全部" },
        { value: "设备类型1", label: "设备类型1" },
        { value: "设备类型2", label: "设备类型2" },
        { value: "设备类型3", label: "设备类型3" }
      ],
      deviceStatus: [
        { value: "全部", label: "全部" },
        { value: "设备工作状态1", label: "设备工作状态1" },
        { value: "设备工作状态2", label: "设备工作状态2" },
        { value: "设备工作状态3", label: "设备工作状态3" }
      ],
      obj: {
        select1: "全部", //有用
        txt: "",
        txt11: "",
        select11: "",
        date: "",
        datas: "",
        dateTime: "",
        number: ""
      },
      list: [],
      currentRow: null,
      pagination: {
        page: 1,
        size: 10,
        total: 0
      },
      tableLoading: false,
      addobj: { name: "" },
      addDialogShow: false
    };
  },

  computed: {},

  created() {
    this.getData();
  },

  methods: {
    download() {
      let loadingInstance = Loading.service({
        fullscreen: true,
        text: "数据生成中"
      });
      setTimeout(() => {
        loadingInstance.close();
      }, 1000);
    },
    clickAdd() {
      this.addDialogShow = true;
      this.currentRow = null;
    },
    clickEdit() {
      if (!this.currentRow) {
        tool.message("请在表格中选择数据", "error");
        return;
      }
      this.addDialogShow = true;
    },
    del() {
      if (!this.currentRow) {
        tool.message("请在表格中选择数据", "error");
      } else {
        this.$confirm("确定要删除吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.$message({
            type: "success",
            duration: 1000,
            message: "操作成功!",
            onClose: () => {
              this.getData();
            }
          });
        });
      }
    },
    submit() {
      console.log(this.addobj);
      this.addDialogShow = false;
    },
    getData(flag) {
      let obj = Object.assign({}, this.obj);
      obj.page = flag ? this.pagination.page : 1;
      this.pagination.page = flag ? this.pagination.page : 1;
      console.log(this.obj, this.pagination, obj);
      this.tableLoading = true;
      setTimeout(() => {
        this.tableLoading = false;
        this.pagination.total = 222;
        this.list = [
          { id: 1 },
          { id: 2 },
          { id: 3 },
          { id: 4 },
          { id: 5 },
          { id: 6 },
          { id: 7 },
          { id: 8 },
          { id: 9 },
          { id: 10 }
        ];
      }, 10);
    },
    reset() {
      this.obj.page = 1;
      this.pagination.page = 1;
      this.getData();
    },
    changeCurrent(val) {
      this.pagination.page = val;
      this.obj.page = val;
      this.getData(true);
    },

    changeSize(e) {
      this.pagination.size = e;
      this.obj.pageSize = e;
      this.getData();
    },
    handleCurrentChange(val) {
      this.currentRow = val;
      //console.log(val.id);
    }
  },

  components: {}
};
</script>

<style lang="less" rel="stylesheet/less">
.monitoring-facility-status-container {
  width: 100%;
  height: auto;
  display: flex;
  align-items: stretch;
  padding: 15px;
  flex-direction: column;
}
</style>
